module.exports = __webpack_public_path__ + "static/img/step_1.dbc0628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/step_1.png
// module id = RM//
// module chunks = 1